import PropTypes from 'prop-types';
import {
  useEffect,
  useState,
  // useCallback,
} from 'react';

import { LeafletCircleMarker } from '../leaflet';

// import { displayJson } from '../../utils';

function PxMapRadarMarkersOverlay(props) {
  const {
    allReady = false,
    mapStateDispatch,
    markerSize = 4,
    markersArrayRef = { current: [] },
    markersPending,
  } = props;
  const [markers, setMarkers] = useState(null);

  //
  // Create Marker container
  //
  useEffect(
    () => {
      mapStateDispatch({ type: 'setMarkersContainerReady', ready: true });

      // Cleanup
      return () => {
        mapStateDispatch({ type: 'setMarkersContainerReady', ready: false });
      };
    },
    [mapStateDispatch],
  );

  // const forceOverlayRefresh = useCallback(
  //   () => {
  //     console.log('PxMap forceOverlayRefresh');
  //   },
  //   [],
  // );

  //
  // Redraw Overlay when needed
  //
  useEffect(
    () => {
    // console.log(`PxMap markersPending=${markersPending}`);
      if (allReady && (!markersPending)) {
      // forceOverlayRefresh();
      // console.log(`markersArrayRef.current.length=${
      //   markersArrayRef.current.length}, #0=${displayJson(markersArrayRef.current[0])}, #1=${
      //   displayJson(markersArrayRef.current[1])}`);
      // markersArrayRef.current.length=1, #0={
      //   "id": "qpI3W)jjvrTpj21jbThw",
      //   "title": "Case #qpI3W)jjvrTpj21jbThw",
      //   "type": "cases",
      //   "code": "police",
      //   "dropPin": true,
      //   "lat": 50.62264658608929,
      //   "lng": 3.025827371797289,
      //   "anchor": {
      //     "x": 0.5,
      //     "y": 1,
      //   },
      //   "opacity": 0.7,
      //   "sizePx": 50,
      //   "color": 16711680,
      //   "zIndex": 404180,
      // },
        if (markersArrayRef.current && markersArrayRef.current.length) {
          const newMarkers = markersArrayRef.current.map((thisMarker) => {
            const {
              id, lat, lng, zIndex, colorHex,
            } = thisMarker;

            return (
              <LeafletCircleMarker
                key={id}
                center={{ lat, lng }}
                radius={markerSize / 2}
                zIndex={zIndex}
                pathOptions={{
                // https://leafletjs.com/reference-1.7.1.html#path
                // fillColor: color,
                // borderWidth: 1,
                // color: 0x0,
                  stroke: true,
                  color: '#FFFFFF',
                  weight: 1.5,
                  opacity: 1,
                  fill: true,
                  fillColor: colorHex,
                  fillOpacity: 1,
                }}
              />
            );
          });

          // console.log(`And newMarkers.length=${newMarkers.length}`);
          // if (newMarkers.length) {
          //   // eslint-disable-next-line no-debugger
          //   debugger;
          // }

          setMarkers(newMarkers);
        } else setMarkers(null);
      }
    },
    [
      allReady, markersPending, markersArrayRef, markerSize,
    ],
  );

  // if (markers && markers.length) return markers[1];pPin": true,
  // "lat": 50.62268312504535,
  // "lng": 3.02608305774998,
  // "anchor": {
  //   "x": 0.5,
  //   "y": 1,
  // },
  // "opacity": 0.7,
  // "sizePx": 75,

  // const circle = (
  //   <Circle
  //     center={{
  //       lat: 50.62268312504535,
  //       lng: 3.02608305774998,
  //     }}
  //     opacity={1}
  //     radius={80}
  //     zIndex={3000000}
  //   />
  // );
  return (markers);
}

PxMapRadarMarkersOverlay.propTypes = {
  allReady: PropTypes.bool,
  mapStateDispatch: PropTypes.func.isRequired,
  markerSize: PropTypes.number,
  markersPending: PropTypes.bool.isRequired,
  markersArrayRef: (PropTypes.shape({
    current: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        type: PropTypes.string,
        lat: PropTypes.number,
        lng: PropTypes.number,
        anchor: PropTypes.shape({
          x: PropTypes.number,
          y: PropTypes.number,
        }),
        angle: PropTypes.number,
        opacity: PropTypes.number,
        color: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
        ]),
      }),
    ),
  })),
};

export default PxMapRadarMarkersOverlay;
